var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-abs',{ref:"LoginAbs",attrs:{"service":_vm.service}})}
var staticRenderFns = []

export { render, staticRenderFns }